import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface VerifiedBadgeProps {
  type?: 'standard' | 'premium';
  size?: 'sm' | 'md';
}

export default function VerifiedBadge({ type = 'standard', size = 'sm' }: VerifiedBadgeProps) {
  if (type === 'premium') {
    return (
      <span className="premium-badge">
        <Icon name="StarIcon" size={size === 'sm' ? 11 : 13} variant="solid" />
        Premium Verified
      </span>
    );
  }
  return (
    <span className="verified-badge">
      <Icon name="CheckBadgeIcon" size={size === 'sm' ? 11 : 13} variant="solid" />
      Verified
    </span>
  );
}